import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path d="M6085 9230 c3 -5 16 -10 28 -9 21 0 21 1 2 9 -28 12 -37 12 -30 0z" />
          <path d="M4678 9223 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M5848 9213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M6168 9213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M5578 9163 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M4648 9093 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M6121 9096 c2 -2 18 -6 34 -10 22 -5 26 -4 15 4 -14 9 -59 15 -49 6z" />
          <path
            d="M4070 9060 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"
          />
          <path d="M6700 9066 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
          <path d="M6758 9043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M4368 9023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M6428 9023 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M3958 9013 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M6828 9013 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M4240 8989 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
          <path d="M6917 8979 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
          <path
            d="M6585 8970 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"
          />
          <path d="M4070 8930 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
          <path
            d="M3590 8850 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"
          />
          <path
            d="M3555 8830 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"
          />
          <path
            d="M3830 8830 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"
          />
          <path
            d="M6940 8837 c0 -3 15 -10 32 -16 18 -6 28 -7 23 -2 -12 10 -55 25 -55
18z"
          />
          <path
            d="M7225 8830 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
          />
          <path
            d="M5009 8750 c-42 -4 -81 -10 -86 -13 -8 -5 24 -456 33 -466 11 -11
243 19 285 37 117 51 160 202 94 332 -51 100 -140 130 -326 110z m183 -101
c62 -28 89 -148 48 -214 -24 -39 -82 -65 -144 -65 -42 0 -44 2 -50 33 -3 17
-8 82 -12 144 l-7 111 29 5 c40 7 106 0 136 -14z"
          />
          <path
            d="M5519 8743 c0 -10 -8 -114 -17 -231 -11 -133 -14 -216 -8 -219 11 -8
284 -28 290 -22 3 2 6 22 8 44 l3 40 -95 8 c-52 5 -97 11 -99 13 -4 3 16 326
23 369 0 6 -23 11 -51 13 -45 3 -53 0 -54 -15z"
          />
          <path
            d="M3584 8704 c-18 -14 -18 -14 6 -3 31 14 36 19 24 19 -6 0 -19 -7 -30
-16z"
          />
          <path
            d="M5975 8708 c-9 -27 -95 -422 -95 -440 0 -10 3 -18 8 -18 4 0 45 -9
92 -20 158 -37 232 -51 237 -46 3 2 7 22 10 44 l5 40 -98 22 c-149 33 -137 26
-130 74 4 22 10 44 14 48 4 4 51 -3 106 -14 109 -22 116 -20 116 38 l0 31
-101 18 -101 19 7 45 c4 25 10 49 13 53 4 3 56 -5 115 -19 61 -14 112 -22 117
-17 5 5 11 25 15 45 l7 35 -149 33 c-81 17 -156 34 -166 37 -9 3 -19 -1 -22
-8z"
          />
          <path d="M7197 8709 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
          <path
            d="M4633 8688 c-19 -6 -33 -18 -33 -27 0 -9 17 -74 39 -144 21 -70 35
-129 32 -131 -3 -2 -37 20 -76 48 -238 176 -225 168 -259 162 -70 -13 -70 -9
2 -251 36 -121 66 -221 68 -223 5 -7 86 22 90 32 2 6 -13 71 -35 144 -21 72
-37 132 -34 132 5 0 41 -25 202 -143 95 -68 101 -71 149 -57 48 13 49 16 23
108 -74 258 -108 357 -121 358 -8 1 -30 -3 -47 -8z"
          />
          <path d="M3160 8585 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20 -6z" />
          <path
            d="M3385 8590 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"
          />
          <path d="M7620 8591 c0 -5 7 -12 16 -15 14 -5 15 -4 4 9 -14 17 -20 19 -20 6z" />
          <path
            d="M7470 8545 c7 -8 17 -15 22 -15 6 0 5 7 -2 15 -7 8 -17 15 -22 15 -6
0 -5 -7 2 -15z"
          />
          <path
            d="M6567 8487 c-26 -28 -106 -113 -177 -187 l-130 -135 37 -17 c54 -24
65 -22 103 17 19 19 39 35 46 35 7 0 50 -14 98 -31 l85 -31 3 -56 3 -56 47
-20 c26 -11 50 -17 53 -14 3 3 1 84 -4 179 -6 96 -11 209 -12 252 -2 78 -2 78
-34 91 -67 29 -67 29 -118 -27z m53 -167 c0 -33 0 -63 -1 -67 -1 -19 -99 11
-99 30 0 13 80 97 92 97 4 0 8 -27 8 -60z"
          />
          <path d="M3075 8520 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
          <path
            d="M7705 8520 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"
          />
          <path
            d="M4028 8469 c-41 -21 -46 -34 -24 -64 7 -11 39 -69 70 -128 72 -139
73 -187 6 -222 -75 -39 -113 -9 -200 155 -35 67 -69 124 -76 127 -14 5 -69
-21 -79 -37 -6 -11 123 -255 154 -292 56 -66 150 -80 242 -36 74 37 109 91
109 170 0 52 -7 71 -74 200 -40 78 -78 143 -82 145 -5 1 -26 -7 -46 -18z"
          />
          <path
            d="M6956 8212 c-44 -70 -99 -157 -123 -193 -24 -36 -43 -71 -43 -77 0
-10 63 -52 79 -52 4 0 20 22 36 50 17 27 34 50 39 50 5 0 30 -13 57 -29 104
-64 176 -64 234 0 88 98 86 173 -8 255 -35 31 -178 124 -190 124 -1 0 -38 -57
-81 -128z m167 -29 c52 -33 66 -51 67 -85 0 -32 -44 -88 -70 -88 -19 0 -67 18
-85 33 -5 4 -18 13 -27 20 -16 11 -13 18 25 79 23 37 43 68 45 68 1 0 21 -12
45 -27z"
          />
          <path d="M2969 8283 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
          <path d="M2894 8218 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z" />
          <path
            d="M7890 8226 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"
          />
          <path
            d="M2705 8210 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M3470 8127 c-27 -13 -113 -76 -168 -124 l-33 -28 66 -85 c137 -177
208 -269 216 -281 5 -9 22 -1 62 32 30 24 77 62 105 83 94 73 114 153 55 220
-21 24 -35 30 -80 34 -53 5 -54 5 -48 33 8 37 -17 90 -54 112 -33 19 -84 21
-121 4z m72 -104 c30 -27 22 -58 -24 -96 -23 -19 -47 -33 -52 -31 -12 5 -56
66 -56 77 0 11 82 67 98 67 9 0 24 -7 34 -17z m150 -149 c9 -20 9 -30 -3 -49
-14 -23 -86 -85 -99 -85 -4 0 -22 19 -40 41 l-33 42 24 19 c81 65 131 76 151
32z"
          />
          <path
            d="M2590 8095 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"
          />
          <path
            d="M8240 8056 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"
          />
          <path
            d="M7455 8026 c-6 -8 -55 -69 -110 -136 -55 -67 -117 -144 -137 -170
l-37 -48 34 -26 c18 -14 38 -26 44 -26 5 0 58 60 117 133 59 72 125 153 147
180 l41 48 -35 29 c-39 33 -50 36 -64 16z"
          />
          <path
            d="M2579 7903 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"
          />
          <path
            d="M3044 7767 c-49 -50 -103 -107 -119 -124 l-29 -33 115 -108 c182
-173 224 -211 230 -212 5 0 124 121 208 212 l33 36 -33 31 -34 30 -84 -90 -84
-90 -33 32 c-19 18 -34 38 -34 44 0 6 29 40 65 75 36 35 65 69 65 75 0 14 -42
55 -56 55 -5 0 -37 -32 -72 -70 -35 -39 -69 -70 -75 -70 -14 0 -67 51 -67 65
0 6 34 44 75 85 41 41 75 79 75 85 0 6 -13 23 -28 38 l-28 27 -90 -93z"
          />
          <path
            d="M8509 7722 c6 -12 16 -24 22 -28 8 -4 8 -1 0 14 -6 12 -16 24 -22 28
-8 4 -8 1 0 -14z"
          />
          <path d="M2215 7639 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
          <path
            d="M8576 7635 c4 -8 11 -15 16 -15 6 0 5 6 -2 15 -7 8 -14 15 -16 15 -2
0 -1 -7 2 -15z"
          />
          <path
            d="M7734 7630 c-44 -14 -124 -87 -145 -135 -65 -143 33 -317 199 -350
36 -7 40 -2 44 54 3 33 1 35 -36 43 -119 25 -163 153 -85 243 63 72 156 69
223 -5 30 -34 36 -47 36 -85 l0 -45 50 0 50 0 0 43 c0 79 -57 169 -137 218
-40 25 -148 35 -199 19z"
          />
          <path
            d="M7384 7597 c-39 -21 -46 -63 -16 -90 28 -26 69 -21 89 9 15 23 15 29
2 52 -17 31 -49 43 -75 29z"
          />
          <path
            d="M8610 7580 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"
          />
          <path
            d="M2295 7550 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M2200 7405 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z"
          />
          <path
            d="M2755 7391 c-40 -25 -71 -60 -139 -156 l-57 -80 28 -22 c57 -46 352
-253 360 -253 9 0 53 65 53 78 0 5 -25 26 -55 46 -30 20 -55 42 -55 49 1 6 9
22 19 35 17 20 28 22 114 22 l95 0 31 48 31 47 -98 5 -97 5 -3 30 c-5 57 -13
75 -45 106 -60 59 -128 74 -182 40z m91 -102 c51 -31 50 -69 -2 -140 l-36 -49
-54 37 c-29 21 -54 44 -54 50 0 29 82 121 109 123 2 0 19 -9 37 -21z"
          />
          <path d="M2016 7323 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
          <path
            d="M5070 7330 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"
          />
          <path d="M5578 7333 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M5628 7333 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M5688 7323 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M8776 7317 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
          <path d="M4775 7260 c-16 -7 -17 -9 -3 -9 9 -1 20 4 23 9 7 11 7 11 -20 0z" />
          <path d="M1965 7239 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
          <path
            d="M2100 7230 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"
          />
          <path
            d="M4680 7228 c-14 -6 -20 -12 -13 -15 7 -2 23 3 35 11 25 18 15 20 -22
4z"
          />
          <path d="M8700 7211 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
          <path
            d="M8025 7168 c-122 -63 -176 -197 -126 -314 90 -208 361 -218 457 -17
22 48 26 66 21 114 -9 102 -69 186 -160 224 -52 22 -143 19 -192 -7z m185 -97
c96 -51 96 -184 1 -248 -48 -32 -94 -38 -144 -19 -113 43 -118 198 -8 260 55
30 104 33 151 7z"
          />
          <path
            d="M4365 7070 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path d="M5848 7033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M5628 6983 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M8820 6976 c0 -8 4 -17 9 -20 5 -4 7 3 4 14 -6 23 -13 26 -13 6z" />
          <path
            d="M6550 6976 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"
          />
          <path d="M6118 6963 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M2442 6915 l-22 -45 98 -46 c53 -25 116 -55 140 -66 83 -40 106 -108
56 -167 -20 -25 -34 -31 -64 -31 -41 0 -60 7 -205 75 -53 25 -101 45 -106 45
-10 0 -39 -64 -39 -86 0 -8 5 -14 10 -14 6 0 63 -25 127 -55 189 -90 249 -93
334 -17 32 28 69 116 69 164 0 44 -36 114 -74 143 -24 19 -286 145 -300 145
-1 0 -12 -20 -24 -45z"
          />
          <path
            d="M4185 6940 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path d="M6038 6933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M5388 6923 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M8978 6915 c5 -11 12 -27 15 -35 5 -13 6 -13 6 1 1 8 -6 24 -15 35
-15 19 -15 19 -6 -1z"
          />
          <path d="M5348 6913 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M7390 6881 c-44 -9 -62 -19 -54 -32 9 -15 144 18 144 36 0 7 -46 4
-90 -4z"
          />
          <path d="M5128 6863 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M9011 6834 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M7210 6833 c-14 -2 -99 -21 -190 -42 -91 -21 -196 -43 -235 -49 -38
-6 -97 -17 -130 -25 -102 -26 -486 -111 -575 -129 -30 -6 -62 -13 -70 -16 -18
-6 -135 -33 -250 -56 -47 -9 -94 -21 -105 -26 -11 -5 -58 -16 -105 -24 -47 -9
-123 -25 -170 -36 -47 -11 -136 -31 -199 -45 -164 -36 -238 -81 -280 -169 -18
-36 -19 -49 -11 -104 11 -67 56 -216 118 -387 104 -290 261 -778 272 -845 6
-41 15 -99 21 -129 14 -82 11 -118 -12 -163 -22 -43 -78 -103 -116 -125 -70
-40 -167 -84 -228 -103 -38 -13 -79 -26 -90 -31 -50 -20 -208 -69 -225 -69
-10 0 -21 -4 -25 -9 -3 -5 -20 -13 -38 -16 -31 -7 -182 -53 -242 -74 -16 -6
-73 -25 -125 -42 -120 -38 -223 -79 -230 -90 -6 -8 -226 -90 -388 -144 -46
-15 -82 -29 -80 -31 2 -2 114 19 249 47 134 28 276 54 314 59 39 5 86 14 105
20 32 10 91 23 310 71 47 10 171 37 275 60 105 22 222 47 260 54 39 8 90 19
115 25 25 6 74 18 110 25 36 7 94 21 130 30 36 9 117 27 180 40 227 47 256 56
306 94 67 51 85 90 74 166 -12 78 -48 203 -116 400 -127 366 -114 328 -229
690 -31 99 -74 232 -95 295 -44 132 -58 217 -40 249 19 36 164 92 520 201 157
48 210 66 380 127 145 52 374 126 475 153 68 18 473 165 483 175 6 6 -61 4
-98 -2z"
          />
          <path d="M4948 6823 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M5628 6803 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M1751 6764 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M5548 6773 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M4638 6753 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M1737 6733 c-4 -3 -7 -13 -7 -22 1 -13 3 -13 11 2 11 19 8 33 -4 20z" />
          <path d="M1866 6723 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
          <path d="M9050 6731 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
          <path
            d="M8430 6618 c-52 -16 -153 -48 -223 -70 -141 -43 -136 -37 -107 -112
l9 -24 133 39 c73 21 136 38 141 36 4 -1 -35 -40 -87 -87 -148 -132 -144 -157
26 -184 137 -22 152 -26 142 -36 -5 -4 -56 -22 -114 -39 -161 -49 -152 -42
-134 -96 9 -25 19 -45 23 -45 4 0 27 6 52 14 24 8 82 26 129 40 162 48 253 77
260 81 5 3 -1 34 -13 70 -24 74 -11 67 -186 90 -63 8 -116 17 -118 19 -2 2 44
46 102 97 l106 94 -7 40 c-6 38 -30 106 -36 104 -2 -1 -46 -15 -98 -31z"
          />
          <path d="M4250 6595 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z" />
          <path d="M3826 6573 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
          <path d="M4940 6586 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
          <path
            d="M4836 6524 c-23 -23 -20 -30 4 -9 11 10 20 20 20 22 0 7 -9 2 -24
-13z"
          />
          <path d="M9121 6524 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M9001 6494 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M1772 6425 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
          <path d="M9021 6434 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M3725 6430 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M2245 6386 c-46 -50 -76 -117 -77 -176 -2 -86 45 -139 129 -147 42
-5 53 -1 81 22 17 14 50 55 73 90 23 35 49 66 58 67 29 7 51 -4 57 -28 10 -40
-4 -73 -51 -120 -25 -24 -45 -47 -45 -51 0 -3 9 -21 21 -40 21 -33 21 -34 47
-17 69 45 121 137 122 212 0 99 -48 153 -136 155 -58 0 -87 -21 -141 -104 -46
-69 -81 -91 -107 -69 -31 25 -12 95 40 150 l24 26 -29 34 -29 35 -37 -39z"
          />
          <path d="M4821 6364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M4251 6334 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M9055 6310 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
          />
          <path d="M3626 6245 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
          <path d="M1581 6174 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M9211 6174 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M1701 6144 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M6878 6133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M1571 6114 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M9221 6114 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M1581 5854 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M6101 5844 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M1651 5824 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M3471 5774 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M7317 5675 c3 -27 7 -52 9 -54 7 -8 2 54 -6 79 -6 17 -7 9 -3 -25z" />
          <path
            d="M3456 5695 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"
          />
          <path d="M4481 5644 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M7331 5554 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M6211 5430 c0 -8 4 -24 9 -35 5 -13 9 -14 9 -5 0 8 -4 24 -9 35 -5
13 -9 14 -9 5z"
          />
          <path d="M4571 5374 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M7332 5250 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
          <path d="M4611 5234 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M3451 5164 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M7322 5140 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
          <path d="M3461 5104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M3471 5030 c0 -8 4 -22 9 -30 12 -18 12 -2 0 25 -6 13 -9 15 -9 5z" />
          <path d="M4641 5004 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M6351 4974 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M3491 4954 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M6376 4917 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
          <path
            d="M8241 4863 c-7 -27 -14 -55 -17 -64 -3 -12 28 -46 101 -110 85 -75
102 -95 88 -100 -10 -3 -71 -14 -135 -24 -65 -10 -122 -23 -126 -29 -10 -12
-32 -96 -32 -118 0 -9 19 -18 48 -25 26 -5 117 -30 202 -56 208 -61 190 -60
206 -7 9 29 10 46 3 51 -6 3 -66 21 -135 40 -68 19 -124 36 -124 39 0 3 60 17
132 30 127 24 133 26 142 53 11 31 21 19 -136 165 -31 28 -50 52 -42 52 8 0
70 -16 137 -35 93 -27 123 -32 129 -22 10 16 22 77 16 83 -8 7 -418 124 -438
124 -4 0 -13 -21 -19 -47z"
          />
          <path
            d="M2373 4885 c-49 -21 -65 -55 -74 -157 -8 -101 -21 -125 -63 -114 -39
10 -54 69 -32 135 9 27 16 54 16 60 0 12 -52 41 -73 41 -21 0 -42 -77 -42
-150 1 -115 58 -190 144 -190 96 0 135 47 146 173 7 92 11 101 41 111 44 14
69 -58 51 -146 -7 -35 -7 -37 29 -48 33 -11 39 -11 51 6 25 34 20 151 -9 212
-35 74 -108 101 -185 67z"
          />
          <path
            d="M4530 4819 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
          <path
            d="M6420 4775 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"
          />
          <path
            d="M3561 4715 c0 -5 6 -21 14 -35 8 -14 14 -20 14 -15 0 6 -6 21 -14 35
-8 14 -14 21 -14 15z"
          />
          <path
            d="M6440 4715 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"
          />
          <path d="M9226 4705 c-3 -9 -6 -24 -5 -33 0 -9 5 -4 10 12 9 32 6 48 -5 21z" />
          <path d="M4288 4703 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M1571 4684 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M5145 4690 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"
          />
          <path d="M1701 4654 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M9091 4654 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M1581 4624 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M7167 4621 c-4 -17 -3 -21 5 -13 5 5 8 16 6 23 -3 8 -7 3 -11 -10z" />
          <path d="M9211 4624 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M3615 4590 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
          />
          <path d="M4848 4593 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M4778 4583 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M9071 4574 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M3640 4551 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
          <path d="M4488 4523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M9055 4490 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path d="M7086 4465 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
          <path
            d="M2502 4414 c-136 -53 -195 -92 -222 -144 -47 -91 3 -225 103 -276 48
-25 117 -13 267 45 74 30 137 55 139 57 3 3 -29 94 -34 94 -1 0 -64 -25 -140
-55 -75 -30 -150 -55 -167 -55 -45 0 -88 48 -88 99 0 58 31 82 185 142 71 28
132 53 134 55 10 9 -33 84 -48 83 -9 0 -67 -20 -129 -45z"
          />
          <path d="M9171 4444 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M3978 4413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M9161 4404 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M3938 4403 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M1771 4364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M1780 4331 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
          <path d="M3780 4301 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
          <path d="M5921 4284 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M8987 4260 c-3 -11 -1 -20 4 -20 5 0 9 9 9 20 0 11 -2 20 -4 20 -2 0
-6 -9 -9 -20z"
          />
          <path d="M6935 4229 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
          <path d="M5869 4203 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
          <path
            d="M8101 4203 c-60 -21 -125 -90 -147 -155 -82 -247 218 -434 398 -248
71 74 93 162 63 251 -22 64 -64 110 -128 142 -64 31 -118 34 -186 10z m121
-93 c110 -31 148 -168 68 -245 -24 -23 -41 -29 -87 -33 -48 -3 -64 0 -92 20
-49 33 -73 69 -78 119 -6 54 24 105 77 131 40 21 61 22 112 8z"
          />
          <path
            d="M6907 4193 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"
          />
          <path d="M9085 4159 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
          <path d="M5785 4134 l-30 -26 35 23 c45 29 45 29 34 29 -5 0 -22 -12 -39 -26z" />
          <path d="M6545 4089 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
          <path d="M6805 4069 c-11 -16 -1 -19 13 -3 7 8 8 14 3 14 -5 0 -13 -5 -16 -11z" />
          <path
            d="M9050 4069 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
          <path d="M5620 4054 l-25 -15 25 7 c14 3 29 10 35 15 15 14 -7 10 -35 -7z" />
          <path
            d="M6505 4050 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path d="M5408 3983 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M9011 3964 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M5345 3960 c-13 -6 -15 -9 -5 -9 8 0 22 4 30 9 18 12 2 12 -25 0z" />
          <path
            d="M2685 3860 c-82 -54 -167 -110 -188 -124 l-37 -26 26 -40 c29 -43 31
-43 109 9 40 27 47 26 68 -9 18 -29 18 -31 -17 -112 l-36 -81 31 -49 c17 -26
34 -48 38 -48 3 0 20 37 36 83 33 88 29 86 103 71 43 -9 136 36 163 80 36 56
22 116 -56 240 -37 58 -73 106 -79 105 -6 0 -78 -45 -161 -99z m184 -78 c37
-59 41 -104 9 -126 -27 -19 -68 -21 -90 -3 -19 14 -68 86 -68 98 0 9 99 79
111 79 4 0 21 -22 38 -48z"
          />
          <path
            d="M6685 3950 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M4105 3940 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
          />
          <path d="M5288 3943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M1816 3877 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
          <path d="M5848 3873 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M3395 3838 c-57 -22 -78 -38 -51 -38 35 0 95 23 101 38 8 22 5 22
-50 0z"
          />
          <path d="M1966 3837 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
          <path d="M8823 3835 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z" />
          <path d="M6494 3794 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
          <path
            d="M8937 3803 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"
          />
          <path d="M4820 3790 c-21 -7 -21 -8 -5 -9 11 0 27 4 35 9 18 11 5 11 -30 0z" />
          <path d="M5348 3763 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path
            d="M7855 3743 c-113 -28 -205 -139 -205 -248 0 -121 121 -245 239 -245
92 0 192 66 232 153 10 24 19 65 19 95 0 49 -2 52 -24 52 -40 0 -76 -18 -70
-34 9 -23 -14 -89 -41 -118 -98 -106 -284 -1 -246 139 13 48 67 101 113 110
35 7 40 16 30 62 -8 37 -15 41 -47 34z"
          />
          <path d="M2020 3721 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
          <path d="M5168 3723 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M4438 3703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M4578 3703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M5078 3703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M4838 3653 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M4628 3613 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M8706 3605 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
          <path d="M2086 3597 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
          <path
            d="M4705 3580 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
          />
          <path
            d="M3050 3459 c-47 -44 -122 -114 -167 -156 -46 -42 -83 -80 -83 -84 0
-4 52 -61 117 -128 l116 -122 29 28 c15 15 28 29 28 32 0 3 -34 42 -75 86 -41
44 -74 85 -75 91 0 5 14 23 30 39 l30 29 74 -73 74 -73 31 23 c17 13 30 26 29
30 -2 4 -33 39 -70 78 -37 39 -65 76 -62 83 3 7 19 24 36 37 l30 24 78 -83 78
-83 31 24 c16 13 30 29 30 34 0 6 -50 63 -112 127 l-112 118 -85 -81z"
          />
          <path d="M5848 3503 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M2010 3491 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
          <path d="M8775 3479 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
          <path d="M5688 3473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M8586 3395 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"
          />
          <path
            d="M3324 3014 c-76 -97 -140 -179 -142 -183 -5 -13 181 -157 224 -174
54 -21 106 -6 141 40 25 33 29 80 9 126 -7 14 -3 17 29 17 46 0 91 41 100 93
11 57 -16 98 -120 182 -52 41 -95 75 -98 75 -2 0 -66 -79 -143 -176z m229 -3
c34 -31 35 -65 3 -86 -22 -15 -27 -15 -53 -1 -15 8 -39 24 -52 35 l-24 19 32
41 c36 45 34 45 94 -8z m-123 -138 c57 -51 65 -69 45 -99 -9 -13 -25 -24 -38
-24 -21 0 -127 64 -127 76 0 11 62 84 71 84 5 0 27 -16 49 -37z"
          />
          <path d="M2200 3176 c0 -2 7 -9 15 -16 13 -11 14 -10 9 4 -5 14 -24 23 -24 12z" />
          <path
            d="M8576 3164 c-5 -14 -4 -15 9 -4 17 14 19 20 6 20 -5 0 -12 -7 -15
-16z"
          />
          <path
            d="M7221 3131 l-35 -30 49 -58 c27 -32 52 -60 55 -63 3 -3 34 -39 70
-80 36 -41 80 -92 99 -112 l34 -37 29 21 c16 11 32 27 35 34 3 7 -19 42 -49
77 -102 122 -241 277 -247 277 -3 0 -21 -13 -40 -29z"
          />
          <path d="M2270 3091 c5 -11 15 -23 21 -27 6 -3 3 5 -6 20 -20 30 -30 35 -15 7z" />
          <path
            d="M8517 3093 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"
          />
          <path
            d="M7686 3064 c-17 -16 -21 -51 -8 -70 29 -43 94 -30 100 20 6 53 -55
87 -92 50z"
          />
          <path
            d="M7002 2949 c-36 -11 -207 -113 -217 -130 -7 -10 21 -57 162 -271 l83
-127 40 26 c22 15 40 30 40 33 0 4 -13 26 -30 48 -16 23 -30 48 -30 55 0 7 17
23 39 35 48 27 108 93 117 127 17 70 -36 171 -106 199 -45 18 -51 18 -98 5z
m60 -100 c25 -13 49 -69 42 -96 -6 -21 -83 -83 -103 -83 -6 0 -29 27 -51 61
-47 68 -46 74 23 108 48 24 60 25 89 10z"
          />
          <path
            d="M2576 2895 c4 -8 11 -15 16 -15 6 0 5 6 -2 15 -7 8 -14 15 -16 15 -2
0 -1 -7 2 -15z"
          />
          <path
            d="M3781 2776 c-68 -126 -91 -184 -91 -228 0 -97 102 -188 211 -188 67
0 116 28 156 88 35 53 133 242 133 258 0 10 -61 44 -79 44 -4 0 -36 -55 -71
-122 -34 -68 -72 -133 -83 -145 -48 -53 -138 -31 -159 38 -11 38 -9 43 52 167
36 70 68 135 72 144 6 14 -1 22 -32 38 -22 11 -41 20 -44 20 -3 0 -32 -51 -65
-114z"
          />
          <path d="M8249 2753 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
          <path d="M2597 2699 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
          <path
            d="M6468 2673 l-36 -15 -6 -102 c-10 -183 -14 -406 -8 -406 4 0 26 8 49
17 44 19 53 34 53 94 l0 37 91 37 92 36 36 -35 c42 -41 46 -42 102 -20 l41 17
-178 178 c-99 99 -183 179 -189 178 -5 -1 -26 -8 -47 -16z m117 -183 l49 -49
-45 -20 c-67 -31 -69 -30 -69 49 0 39 4 70 8 70 4 0 30 -22 57 -50z"
          />
          <path
            d="M4251 2431 c-34 -119 -61 -221 -61 -227 0 -10 50 -27 84 -28 10 -1
14 11 55 159 14 55 31 98 36 96 9 -4 42 -82 108 -256 26 -68 29 -71 73 -84 26
-8 49 -10 53 -5 4 5 34 101 66 214 32 113 60 210 62 215 2 6 -18 18 -45 27
l-50 15 -31 -106 c-17 -58 -34 -121 -37 -139 -4 -18 -10 -34 -14 -37 -4 -2
-20 28 -35 68 -15 40 -33 86 -41 102 -7 17 -26 64 -42 105 -28 73 -30 74 -74
86 l-45 11 -62 -216z"
          />
          <path d="M8104 2608 l-29 -33 33 29 c17 17 32 31 32 33 0 8 -8 1 -36 -29z" />
          <path
            d="M2705 2590 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
          />
          <path
            d="M7891 2580 c-13 -11 -19 -20 -14 -20 6 0 18 9 28 20 23 25 17 25 -14
0z"
          />
          <path
            d="M5990 2523 c-80 -19 -146 -36 -148 -37 -2 -3 20 -102 79 -356 12 -52
22 -96 24 -98 1 -1 58 11 126 27 68 16 141 32 161 35 21 4 40 10 42 15 8 12
-13 81 -25 81 -13 0 -182 -38 -201 -45 -19 -7 -32 13 -41 62 l-6 31 100 23
101 23 -6 34 c-3 20 -9 39 -13 43 -4 4 -44 -1 -88 -12 -117 -28 -121 -27 -128
23 -3 23 -4 45 -2 48 2 4 52 17 110 30 63 14 105 28 105 35 0 39 -14 75 -29
74 -9 0 -81 -16 -161 -36z"
          />
          <path
            d="M8039 2543 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"
          />
          <path
            d="M2770 2536 c0 -4 7 -14 15 -22 8 -9 15 -11 15 -6 0 5 -7 15 -15 22
-8 7 -15 9 -15 6z"
          />
          <path
            d="M4857 2422 c-19 -213 -29 -393 -23 -399 4 -4 67 -9 140 -11 120 -4
136 -2 174 17 115 58 155 229 83 343 -46 72 -106 93 -312 111 l-56 5 -6 -66z
m240 -56 c46 -23 66 -62 66 -126 0 -97 -48 -144 -149 -143 -34 0 -66 3 -70 6
-7 4 7 263 15 286 3 9 111 -9 138 -23z"
          />
          <path
            d="M5425 2358 c3 -51 10 -145 16 -208 5 -63 9 -128 9 -144 l0 -28 63 6
c34 3 101 8 150 12 l87 6 0 45 0 44 -102 -3 -103 -3 -12 170 c-6 94 -11 176
-12 183 -1 8 -18 12 -52 12 l-51 0 7 -92z"
          />
          <path
            d="M2990 2350 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"
          />
          <path
            d="M3075 2280 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"
          />
          <path d="M7710 2280 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
          <path
            d="M3300 2260 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"
          />
          <path
            d="M7480 2259 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
          <path
            d="M3150 2226 c0 -2 7 -9 15 -16 9 -7 15 -8 15 -2 0 5 -7 12 -15 16 -8
3 -15 4 -15 2z"
          />
          <path d="M7630 2220 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z" />
          <path
            d="M7394 2205 c-10 -8 -14 -14 -9 -14 6 0 19 6 29 14 11 8 15 15 10 15
-6 0 -19 -7 -30 -15z"
          />
          <path d="M3580 2096 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
          <path d="M7190 2090 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
          <path d="M7330 2030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
          <path d="M3800 1984 c0 -7 52 -25 57 -20 2 2 -10 8 -26 14 -17 6 -31 9 -31 6z" />
          <path
            d="M6973 1980 c-13 -5 -23 -11 -23 -14 0 -7 40 6 46 15 6 10 6 10 -23
-1z"
          />
          <path
            d="M3560 1970 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"
          />
          <path
            d="M7225 1970 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path d="M6715 1870 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
          <path
            d="M4195 1830 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"
          />
          <path d="M6828 1783 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M4351 1776 c2 -2 20 -6 39 -10 25 -4 31 -3 20 4 -14 9 -69 15 -59 6z" />
          <path d="M6418 1773 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M4065 1742 c6 -5 24 -12 40 -16 34 -7 15 7 -25 19 -16 5 -22 4 -15
-3z"
          />
          <path d="M6710 1740 c-13 -8 -13 -10 2 -10 9 0 20 5 23 10 8 13 -5 13 -25 0z" />
          <path d="M6218 1723 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M6630 1710 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"
          />
          <path d="M4648 1703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M6128 1703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M4438 1623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M4938 1583 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M6168 1583 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M4685 1570 c28 -12 37 -12 30 0 -3 6 -16 10 -28 9 -21 0 -21 -1 -2
-9z"
          />
          <path d="M6108 1573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
